import { passengerTypes } from 'types/passengers';

const getPassengerLabel = (intl, passenger, isGroupBooking) => {
  const { firstName, lastName, id, type } = passenger;
  const name = `${firstName} ${lastName}`;

  if (!isGroupBooking) return name;

  const typeKey = passengerTypes[type];
  const paxType = typeKey ? intl.formatMessage({ id: `passengerType.${typeKey}` }) : type;

  const paxId = id.replace(/\D+/g, '') || id;

  return intl.formatMessage({ id: 'addAssistance.paxIdLabel' }, { paxId, paxType });
};

export default getPassengerLabel;
